import React from 'react';

import type { ButtonBaseProps } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

import { AlineButton } from './generic/AlineButton';

const useStyles = makeStyles()(theme => ({
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    width: '100%',
  },
  cancelButton: {
    flexGrow: 1,
    minWidth: 100,
  },
  primaryButton: {
    flexGrow: 1,
    minWidth: 100,
  },
}));

interface FormSubmitButtonsProps extends ButtonBaseProps {
  primaryButtonText: string;
  className?: string;
  disableCancel?: boolean;
  disableSubmit?: boolean;
  loading?: boolean;
  onClickCancel?: (event: React.MouseEvent) => void;
  onClickSubmit?: (event: React.MouseEvent) => void;
}

export const FormSubmitButtons = React.memo(function FormSubmitButtons({
  className,
  disableCancel,
  disableSubmit,
  loading,
  onClickCancel,
  onClickSubmit,
  primaryButtonText,
}: FormSubmitButtonsProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={clsx(className, classes.buttonContainer)}>
      <AlineButton
        className={classes.cancelButton}
        color="primary"
        data-cy="cancel-button"
        disabled={disableCancel}
        type="reset"
        variant="outlined"
        onClick={onClickCancel}
      >
        Cancel
      </AlineButton>
      <AlineButton
        className={classes.primaryButton}
        color="primary"
        data-cy="submit-button"
        disabled={disableSubmit}
        loading={loading}
        type="submit"
        variant="contained"
        onClick={onClickSubmit}
      >
        {primaryButtonText}
      </AlineButton>
    </div>
  );
});
